import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { HashLoader } from "react-spinners";
import FadeInAnimation from "../../components/animations/FadeInAnimation";
import FootBallNews from "../../components/footballNews/FootBallNews";
import Header from "../../components/header/Header";
import RightSideNav from "../../components/rightside/RightSideNav";
import SideNav from "../../components/sidenav/SideNav";
import SliderDiv from "../../components/slidercard/Slider";
import Skeleton from "react-loading-skeleton";
import { useFetchProfilesQuery } from "../../store/api/apiSlice";
import AdvertisementSlider from "../../components/AdvertisementSlider/AdvertisementSlider";
import HeaderEdit from "../../components/HeaderEdit/HeaderEdit";
import Footer from "../../components/Footer/Footer";

const Home = () => {
  const [profileData, setProfileData] = useState(null);

  const [error, setError] = useState(null);
  const [selected, setSelected] = useState(null);
  const [image, setImage] = useState(null);
  const baseUrl = process.env.REACT_APP_SERVER_URL;
  const secretKey = process.env.REACT_APP_SECRET_KEY;
  const {
    data: profileData2,
    isLoading: isprofileLoading,
    refetch: refetchProfile,
  } = useFetchProfilesQuery();

  useEffect(() => {
    const fetchProfile = async () => {
      const tokenData = localStorage.getItem("token");
      const xAuthToken = tokenData ? JSON.parse(tokenData).token : null;

      try {
        const response = await fetch(`${baseUrl}/api/auth/user-profile`, {
          method: "GET",
          headers: {
            "secret-key": secretKey,
            "x-auth-token": xAuthToken,
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          const data = await response.json();
          setProfileData(data.user);
          localStorage.setItem("user", JSON.stringify(data.user));
        } else {
          setError("Failed to fetch profile");
        }
      } catch (error) {
        setError("Error fetching profile");
      }
    };

    fetchProfile();
  }, [baseUrl, secretKey]);

  if (error) {
    return <Navigate to="/login" />;
  }

  return (
    <div>
      <FadeInAnimation>
        <Header />
      </FadeInAnimation>
      <section className="mt-4">
        <HeaderEdit />
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              {isprofileLoading ? (
                <Skeleton width={180} height={180} />
              ) : (
                <SliderDiv />
              )}
              <AdvertisementSlider />
            </div>

            <div className="col-md-3">
              <div className="bg-white hiddensm">
                <SideNav
                  selected={selected}
                  setSelected={setSelected}
                  image={image}
                  setImage={setImage}
                />
              </div>
            </div>
            <div className="col-md-9">
              <div className="row" style={{ marginTop: "12px" }}>
                <div className="col-md-8">
                  {isprofileLoading ? (
                    <Skeleton height={600} />
                  ) : (
                    <FootBallNews />
                  )}
                </div>
                <div className="col-md-4">
                  <div className="bg-white hiddensm">
                    <h4 className="broughttoyou2">CSFA POLL - SURVEY</h4>
                    {isprofileLoading ? (
                      <Skeleton height={400} width={380} />
                    ) : (
                      <RightSideNav />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer/>
    </div>
  );
};

export default Home;
